import { connect } from 'react-redux'
import { IStoreState, ICreateTeamMemberPermissionDTO, IUpdateTeamMemberPermissionDTO } from '../../types'
import TeamMemberPermissionPane from '../../components/team-members/view/TeamMemberPermissionPane'
import {
  fetchTeamMemberPermission,
  createTeamMemberPermission,
  updateTeamMemberPermission
} from '../../state/actions/team-member-permission'
import { fetchServiceList } from '../../state/actions/services'
import { SERVICE_LIST_TYPE } from '../../state/constants/index'

export function mapStateToProps(state: IStoreState, ownProps: any) {
  const { id } = ownProps
  return {
    id,
    orgId: state.organizations.currentOrgId,
    services: Object.values(state.service.items),
    permission: state.teamMemberPermission
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    fetchTeamMemberPermission: (id: string) => dispatch(fetchTeamMemberPermission(id)),
    createTeamMemberPermission: (tmp: ICreateTeamMemberPermissionDTO) => dispatch(createTeamMemberPermission(tmp)),
    updateTeamMemberPermission: (tmp: IUpdateTeamMemberPermissionDTO) => dispatch(updateTeamMemberPermission(tmp)),
    fetchServices: (orgId: string) => dispatch(fetchServiceList(SERVICE_LIST_TYPE.ACTIVE, orgId))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TeamMemberPermissionPane)



// WEBPACK FOOTER //
// ./src/containers/team-members/TeamMemberPermissionPane.ts